import theme from '../../../utils/style/theme'
import {
  totalWorkforce,
  femaleWorkforce,
  percentWomen,
  legislators,
  womenInParl,
  womenInMinis,
  overallAverageWage,
  womenAverageWage,
  genderPayGapBlack,
  techWorkforce,
  workforceInTech,
  femaleTechWorkforce,
  womenInTech,
  diffWorkforceAndTech,
  STEM,
  techAverageWage,
  techWomenAverageWage,
  overallPayGap,
  genderInequality,
  payGap5YearsAgo,
  payGapComparison,
} from './icons'

export const headingGroups = {
  en: {
    Country: 'Country',
    WorkforceToday: 'Workforce Today',
    TechIndustryToday: 'Tech Industry Today',
    'Inqualifty&Opportunity': 'Inequality & Opportunity',
  },
  de: {
    Country: 'Land',
    WorkforceToday: 'Alle Erwerbstätige',
    TechIndustryToday: 'IT-Branche',
    'Inqualifty&Opportunity': 'Ungleichheit und Chancen',
  },
  nl: {
    Country: 'Land',
    WorkforceToday: 'Beroepsbevolking (huidig)',
    TechIndustryToday: 'Techindustrie (huidig)',
    'Inqualifty&Opportunity': 'Ongelijkheid & Kansen',
  },
}

export const headings = [
  {
    icon: totalWorkforce,
    bg: theme.blueHeadBg1,
    title: {
      en: 'Total Workforce (Millions)',
      de: 'Anzahl aller Erwerbstätigen (in Millionen)',
      nl: 'Totale Beroepsbevolking (Miljoenen)',
    },
  },
  {
    icon: femaleWorkforce,
    bg: theme.blueHeadBg1,
    title: {
      en: 'Female Workforce (Millions)',
      de: 'Weibliche Erwerbstätige (in Millionen)',
      nl: 'Vrouwelijke Beroepsbevolking (Miljoenen)',
    },
  },
  {
    icon: percentWomen,
    bg: theme.blueHeadBg1,
    title: { en: '% Women', de: 'Frauenanteil (in %)', nl: '% Vrouwen' },
  },

  {
    icon: legislators,
    bg: theme.blueHeadBg2,
    title: {
      en: '% Women Legislators, Senior Officials, and Managers',
      de:
        'Frauen in hochrangigen Beamtenstellen, gesetzgebenden und geschäftsführenden Positionen (in %)',
      nl: '% Vrouwelijke Wetgevers, Hoge Ambtenaren en Managers',
    },
  },
  {
    icon: womenInParl,
    bg: theme.blueHeadBg2,
    title: {
      en: '% Women in Parliament',
      de: 'Frauenanteil im Parlament (in %)',
      nl: '% Vrouwen in het Parlement',
    },
  },
  {
    icon: womenInMinis,
    bg: theme.blueHeadBg2,
    title: {
      en: '% Women in Ministerial Positions',
      de: 'Frauenanteil in Ministerämtern (in %)',
      nl: '% Vrouwen met Ministeriële Posities',
    },
  },

  {
    icon: overallAverageWage,
    bg: theme.blueHeadBg1,
    title: cur => ({
      en: `Overall Workforce Average Wage (in ${cur})`,
      de: `Durschnittsgehalt aller Erwerbstätigen (in €)`,
      nl: `Totale Beroepsbevolking Gemiddeld Inkomen (€)`,
    }),
  },
  {
    icon: womenAverageWage,
    bg: theme.blueHeadBg1,
    title: cur => ({
      en: `Women's Average Wage (${cur})`,
      de: 'Durschnittsgehalt von Frauen (in €)',
      nl: 'Gemiddeld Inkomen Vrouwen (€)',
    }),
  },
  {
    icon: genderPayGapBlack,
    bg: theme.blueHeadBg1,
    title: {
      en: 'Gender Pay Gap (%)',
      de: 'Geschlechtsspezifisches Lohngefälle (in %)',
      nl: 'Inkomensongelijkheid Mannen en Vrouwen (%)',
    },
  },

  {
    icon: techWorkforce,
    bg: theme.greenHeadBg1,
    title: {
      en: 'Tech Workforce (Thousands)',
      de: 'Erwerbstätige in IT-Berufen (in Tausend)',
      nl: 'Tech Beroepsbevolking (x 1.000)',
    },
  },
  {
    icon: workforceInTech,
    bg: theme.greenHeadBg1,
    title: {
      en: '% Workforce in Tech',
      de: 'Erwerbstätige in IT-Berufen (in %)',
      nl: '% Beroepsbevolking in Tech',
    },
  },
  {
    icon: femaleTechWorkforce,
    bg: theme.greenHeadBg1,
    title: {
      en: 'Female Tech Workforce (Thousands)',
      de: 'Frauen in IT-Berufen (in Tausend)',
      nl: 'Vrouwelijke Tech Beroepsbevolking (x 1.000)',
    },
  },
  {
    icon: womenInTech,
    bg: theme.greenHeadBg1,
    title: {
      en: '% Women in Tech',
      de: 'Frauen in IT-Berufen (in %)',
      nl: '% Vrouwen in Tech',
    },
  },
  {
    icon: diffWorkforceAndTech,
    bg: theme.greenHeadBg1,
    title: {
      en: '% Difference of Women in Workforce and Women in Tech',
      de:
        'Unterschied Frauenanteil allgemein und Frauenanteil in IT-Berufen (in %)',
      nl: '% Verschil Vrouwen in Beroepsbevolking en Vrouwen in Tech',
    },
  },
  {
    icon: STEM,
    bg: theme.greenHeadBg1,
    title: {
      en: 'Female STEM Graduates (%)',
      de: 'MINT-Absolventinnen (in %)',
      nl: 'Vrouwelijke STEM-Afgestudeerden (%)',
    },
  },
  {
    icon: techAverageWage,
    bg: theme.greenHeadBg1,
    title: cur => ({
      en: `Tech Average Wage (${cur})`,
      de: 'Durchschnittsgehalt in IT-Berufen (in €)',
      nl: 'Tech Gemiddeld Inkomen (€)',
    }),
  },
  {
    icon: techWomenAverageWage,
    bg: theme.greenHeadBg1,
    title: cur => ({
      en: `Tech Average Wage for Women (${cur})`,
      de: 'Durschnittsgehalt von Frauen in IT-Berufen (in €)',
      nl: 'Tech Gemiddeld Inkomen voor Vrouwen (€)',
    }),
  },
  {
    icon: genderPayGapBlack,
    bg: theme.greenHeadBg1,
    title: {
      en: 'Gender Pay Gap in Tech (%)',
      de: 'Geschlechtsspezifisches Lohngefälle (in %)',
      nl: 'Inkomensongelijkheid tussen Mannen en Vrouwen in Tech (%)',
    },
  },

  {
    icon: overallPayGap,
    bg: theme.greenGroupBg,
    light: true,
    title: {
      en: '% Difference of Overall Gender Pay Gap and Gender Pay Gap in Tech',
      de:
        'Unterschied zwischen dem allgemeinen geschlechtsspezifischen Lohngefälle und dem Lohngefälle in der IT-Branche',
      nl:
        '% Verschil in Overall Inkomensongelijkheid en Inkomensongelijkheid in Tech',
    },
  },

  {
    icon: genderInequality,
    bg: theme.orangeHeadBg1,
    title: {
      en: 'Gender Inequality Index (Score, 0 = equality)',
      de: 'Geschlechterungleichheits-Index (Punktzahl, 0 = Gleichberechtigung)',
      nl: 'Gender Inequality Index (Score, 0 = gelijkheid)',
    },
  },
  {
    icon: payGap5YearsAgo,
    bg: theme.orangeHeadBg1,
    title: {
      en: 'Gender Pay Gap 2010',
      de: 'Geschlechtsspezifisches Lohngefälle 2010',
      nl: 'Inkomensongelijkheid tussen Mannen en Vrouwen in 2010',
    },
  },
  {
    icon: payGapComparison,
    bg: theme.orangeHeadBg1,
    title: {
      en: 'Comparison of Gender Pay Gap From 2010 To 2015',
      de: 'Vergleich der geschlechtsspezifischen Lohngefälle von 2010 und 2015',
      nl: 'Vergelijking Inkomensongelijkheid tussen 2010 en 2015',
    },
  },
]

export const countriesEN = [
  'Portugal',
  'United States',
  'Latvia',
  'Finland',
  'France',
  'Sweden',
  'United Kingdom',
  'Estonia',
  'Spain',
  'Cyprus',
  'Iceland',
  'Turkey',
  'New Zealand',
  'Netherlands',
  'Canada',
  'Croatia',
  'Ireland',
  'Austria',
  'Bulgaria',
  'South Korea',
  'Mexico',
  'Norway',
  'Switzerland',
  'Chile',
  'Israel',
  'Belgium',
  'Germany',
  'Japan',
  'Denmark',
  'Australia',
  'Malta',
  'Slovenia',
  'Hungary',
  'Italy',
  'Czech Republic',
  'Romania',
  'Luxembourg',
  'Slovak Republic',
  'Greece',
  'Lithuania',
  'Poland',
]

export const countriesDE = [
  'Portugal',
  'USA',
  'Lettland',
  'Finnland',
  'Frankreich',
  'Schweden',
  'Großbritannien',
  'Estland',
  'Spanien',
  'Zypern',
  'Island',
  'Türkei',
  'Neuseeland',
  'Niederlande',
  'Kanada',
  'Kroatien',
  'Irland',
  'Österreich',
  'Bulgarien',
  'Südkorea',
  'Mexiko',
  'Norwegen',
  'Schweiz',
  'Chile',
  'Israel',
  'Belgien',
  'Deutschland',
  'Japan',
  'Dänemark',
  'Australien',
  'Malta',
  'Slowenien',
  'Ungarn',
  'Italien',
  'Tschechien',
  'Rumänien',
  'Luxemburg',
  'Slowakische Republik',
  'Griechenland',
  'Litauen',
  'Polen',
]

export const countriesNL = [
  'Portugal',
  'Verenigde Staten',
  'Letland',
  'Finland',
  'Frankrijk',
  'Zweden',
  'Verenigd Koninkrijk',
  'Estland',
  'Spanje',
  'Cyprus',
  'IJsland',
  'Turkije',
  'Nieuw-Zeeland',
  'Nederland',
  'Canada',
  'Kroatië',
  'Ierland',
  'Oostenrijk',
  'Bulgarije',
  'Zuid-Korea',
  'Mexico',
  'Noorwegen',
  'Zwitserland',
  'Chili',
  'Israël',
  'België',
  'Duitsland',
  'Japan',
  'Denemarken',
  'Australië',
  'Malta',
  'Slovenië',
  'Hongarije',
  'Italië',
  'Tsjechië',
  'Roemenië',
  'Luxemburg',
  'Slowakije',
  'Griekenland',
  'Litouwen',
  'Polen',
]

export const countries = {
  en: countriesEN,
  de: countriesDE,
  nl: countriesNL,
}

export const rowsUSD = [
  [
    0,
    '5.18',
    '2.53',
    '48.78%',
    '32.4%',
    '34.6%',
    '28.6%',
    '24,529',
    '20,026',
    '18.36%',
    '108.80',
    '2.10%',
    '17.50',
    '16.08%',
    '-32.69%',
    '30.56%',
    '38,878',
    '34,563',
    '11.10%',
    '7.26%',
    '0.091',
    '13.13%',
    '5.23%',
  ],
  [
    1,
    '159.19',
    '74.43',
    '46.76%',
    '43.5%',
    '19.4%',
    '25.9%',
    '60,154',
    '48,795',
    '18.88%',
    '6049.11',
    '3.80%',
    '1488.64',
    '24.61%',
    '-22.15%',
    '24.24%',
    '98,265',
    '86,608',
    '11.86%',
    '7.02%',
    '0.203',
    '18.81%',
    '0.07%',
  ],
  [
    2,
    '0.99',
    '0.50',
    '50.25%',
    '44.4%',
    '18.0%',
    '23.1%',
    '22,389',
    '18,583',
    '17.00%',
    '19.70',
    '1.99%',
    '4.90',
    '24.87%',
    '-25.38%',
    '16.67%',
    '40,485',
    '36,072',
    '10.90%',
    '6.10%',
    '0.191',
    '17.28%',
    '-0.28%',
  ],
  [
    3,
    '2.68',
    '1.29',
    '48.14%',
    '33.8%',
    '41.5%',
    '62.5%',
    '42,127',
    '34,680',
    '17.68%',
    '162.30',
    '6.04%',
    '35.60',
    '21.93%',
    '-26.20%',
    '20.00%',
    '54,303',
    '46,972',
    '13.50%',
    '4.18%',
    '0.056',
    '19.59%',
    '-1.91%',
  ],
  [
    4,
    '29.56',
    '14.22',
    '48.13%',
    '31.5%',
    '25.9%',
    '50.0%',
    '42,992',
    '36,199',
    '15.80%',
    '1003.80',
    '3.40%',
    '181.60',
    '18.09%',
    '-30.03%',
    '25.37%',
    '59,254',
    '52,262',
    '11.80%',
    '4.00%',
    '0.102',
    '12.36%',
    '3.44%',
  ],
  [
    5,
    '5.28',
    '2.51',
    '47.62%',
    '39.4%',
    '43.5%',
    '52.2%',
    '42,816',
    '36,822',
    '14.00%',
    '310.80',
    '5.89%',
    '64.70',
    '20.82%',
    '-26.80%',
    '22.48%',
    '55,656',
    '49,757',
    '10.60%',
    '3.40%',
    '0.048',
    '14.86%',
    '-0.86%',
  ],
  [
    6,
    '33.23',
    '15.51',
    '46.69%',
    '35.5%',
    '29.6%',
    '22.5%',
    '42,835',
    '34,717',
    '18.95%',
    '1608.20',
    '4.84%',
    '260.60',
    '16.20%',
    '-30.48%',
    '31.03%',
    '59,136',
    '49,201',
    '16.80%',
    '2.15%',
    '0.131',
    '19.37%',
    '-0.41%',
  ],
  [
    7,
    '0.69',
    '0.34',
    '48.54%',
    '30.6%',
    '23.7%',
    '46.2%',
    '23,621',
    '17,267',
    '26.90%',
    '34.10',
    '4.93%',
    '6.40',
    '18.77%',
    '-29.77%',
    '21.26%',
    '36,260',
    '27,014',
    '25.50%',
    '1.40%',
    '0.131',
    '27.75%',
    '-0.85%',
  ],
  [
    8,
    '22.82',
    '10.61',
    '46.48%',
    '31.5%',
    '40.1%',
    '30.6%',
    '37,333',
    '31,770',
    '14.90%',
    '557.60',
    '2.44%',
    '85.80',
    '15.39%',
    '-31.10%',
    '25.93%',
    '48,554',
    '41,902',
    '13.70%',
    '1.20%',
    '0.081',
    '14.85%',
    '0.05%',
  ],
  [
    9,
    '0.40',
    '0.19',
    '48.61%',
    '22.5%',
    '19.4%',
    '9.1%',
    '35,475',
    '30,508',
    '14.00%',
    '7.90',
    '1.99%',
    '1.60',
    '20.25%',
    '-28.36%',
    '28.57%',
    '40,445',
    '34,985',
    '13.50%',
    '0.50%',
    '0.116',
    '16.80%',
    '-2.80%',
  ],
  [
    10,
    '0.20',
    '0.09',
    '46.87%',
    '38.3%',
    '41.2%',
    '44.4%',
    '55,984',
    '48,305',
    '13.72%',
    '7.70',
    '3.92%',
    '1.70',
    '22.08%',
    '-24.79%',
    '27.54%',
    '55,984',
    '47,866',
    '14.50%',
    '-0.78%',
    '0.051',
    '16.01%',
    '-2.29%',
  ],
  [
    11,
    '30.52',
    '9.63',
    '31.55%',
    '13.0%',
    '15.3%',
    '3.8%',
    '22,995',
    '21,413',
    '6.88%',
    '245.20',
    '0.80%',
    '24.30',
    '9.91%',
    '-21.64%',
    '37.11%',
    '50,335',
    '46,098',
    '8.42%',
    '-1.54%',
    '0.328',
    '3.10%',
    '3.78%',
  ],
  [
    12,
    '2.60',
    '1.23',
    '47.39%',
    '40.1%',
    '31.5%',
    '33.3%',
    '39,397',
    '36,277',
    '7.92%',
    '96.13',
    '3.70%',
    '17.24',
    '17.93%',
    '-29.46%',
    '27.01%',
    '50,155',
    '45,220',
    '9.84%',
    '-1.92%',
    '0.158',
    '7.01%',
    '0.91%',
  ],
  [
    13,
    '8.97',
    '4.16',
    '46.42%',
    '25.9%',
    '37.5%',
    '46.8%',
    '52,833',
    '44,327',
    '16.10%',
    '422.20',
    '4.71%',
    '65.70',
    '15.56%',
    '-30.85%',
    '18.70%',
    '69,910',
    '57,047',
    '18.40%',
    '-2.30%',
    '0.044',
    '17.84%',
    '-1.74%',
  ],
  [
    14,
    '19.44',
    '9.20',
    '47.32%',
    '35.5%',
    '25.9%',
    '30.6%',
    '48,403',
    '39,387',
    '18.63%',
    '900.30',
    '4.63%',
    '224.00',
    '24.88%',
    '-22.44%',
    '24.81%',
    '67,282',
    '53,128',
    '21.04%',
    '-2.41%',
    '0.098',
    '18.98%',
    '-0.35%',
  ],
  [
    15,
    '1.76',
    '0.81',
    '46.04%',
    '23.1%',
    '15.3%',
    '20.0%',
    '23,848',
    '21,367',
    '10.40%',
    '52.30',
    '2.98%',
    '6.90',
    '13.19%',
    '-32.84%',
    '26.47%',
    '34,368',
    '29,900',
    '13.00%',
    '-2.60%',
    '0.141',
    '5.70%',
    '4.70%',
  ],
  [
    16,
    '2.19',
    '0.99',
    '45.09%',
    '34.2%',
    '22.5%',
    '28.6%',
    '51,681',
    '44,355',
    '14.17%',
    '78.10',
    '3.56%',
    '14.80',
    '18.95%',
    '-26.14%',
    '24.81%',
    '73,226',
    '60,558',
    '17.30%',
    '-3.13%',
    '0.127',
    '13.37%',
    '0.80%',
  ],
  [
    17,
    '4.49',
    '2.10',
    '46.82%',
    '29.6%',
    '30.6%',
    '30.6%',
    '48,295',
    '38,939',
    '19.37%',
    '178.60',
    '3.98%',
    '30.70',
    '17.19%',
    '-29.63%',
    '20.63%',
    '66,501',
    '51,405',
    '22.70%',
    '-3.33%',
    '0.078',
    '21.59%',
    '-2.22%',
  ],
  [
    18,
    '3.31',
    '1.55',
    '46.91%',
    '36.7%',
    '20.6%',
    '35.1%',
    '14,513',
    '12,278',
    '15.40%',
    '80.90',
    '2.44%',
    '24.50',
    '30.28%',
    '-16.63%',
    '28.57%',
    '33,122',
    '26,762',
    '19.20%',
    '-3.80%',
    '0.223',
    '13.00%',
    '2.40%',
  ],
  [
    19,
    '27.25',
    '11.53',
    '42.31%',
    '10.7%',
    '17.4%',
    '5.7%',
    '32,399',
    '20,354',
    '37.18%',
    '1008.15',
    '3.70%',
    '161.41',
    '16.01%',
    '-26.30%',
    '21.26%',
    '41,246',
    '22,199',
    '41.17%',
    '-3.99%',
    '0.067',
    '39.61%',
    '-2.43%',
  ],
  [
    20,
    '53.68',
    '20.50',
    '38.20%',
    '35.9%',
    '42.5%',
    '17.4%',
    '15,311',
    '12,759',
    '16.67%',
    '461.29',
    '0.86%',
    '65.61',
    '14.22%',
    '-23.97%',
    '29.08%',
    '19,492',
    '15,456',
    '20.70%',
    '-4.04%',
    '0.345',
    '11.63%',
    '5.04%',
  ],
  [
    21,
    '2.77',
    '1.30',
    '47.03%',
    '35.9%',
    '39.8%',
    '47.1%',
    '53,643',
    '47,736',
    '11.01%',
    '113.10',
    '4.09%',
    '22.00',
    '19.45%',
    '-27.58%',
    '19.35%',
    '69,095',
    '58,454',
    '15.40%',
    '-4.39%',
    '0.053',
    '12.08%',
    '-1.07%',
  ],
  [
    22,
    '4.84',
    '2.26',
    '46.60%',
    '35.1%',
    '32.0%',
    '42.9%',
    '60,124',
    '49,482',
    '17.70%',
    '216.30',
    '4.47%',
    '31.60',
    '14.61%',
    '-31.99%',
    '21.88%',
    '75,971',
    '59,029',
    '22.30%',
    '-4.60%',
    '0.040',
    '18.93%',
    '-1.23%',
  ],
  [
    23,
    '8.68',
    '3.56',
    '41.04%',
    '25.4%',
    '16.0%',
    '34.6%',
    '28,434',
    '22,448',
    '21.05%',
    '321.09',
    '3.70%',
    '49.86',
    '15.53%',
    '-25.51%',
    '15.97%',
    '36,198',
    '26,732',
    '26.15%',
    '-5.10%',
    '0.322',
    '16.00%',
    '5.05%',
  ],
  [
    24,
    '3.93',
    '1.86',
    '47.30%',
    '32.9%',
    '26.5%',
    '18.0%',
    '34,023',
    '26,596',
    '21.83%',
    '236.27',
    '6.02%',
    '25.99',
    '11.00%',
    '-36.30%',
    '24.81%',
    '43,313',
    '31,568',
    '27.12%',
    '-5.29%',
    '0.103',
    '20.70%',
    '1.13%',
  ],
  [
    25,
    '4.98',
    '2.29',
    '46.11%',
    '32.4%',
    '39.4%',
    '23.1%',
    '49,587',
    '46,364',
    '6.50%',
    '193.80',
    '3.89%',
    '27.30',
    '14.09%',
    '-32.02%',
    '18.03%',
    '61,564',
    '54,299',
    '11.80%',
    '-5.30%',
    '0.073',
    '8.62%',
    '-2.12%',
  ],
  [
    26,
    '43.04',
    '19.95',
    '46.35%',
    '29.1%',
    '36.3%',
    '33.3%',
    '46,389',
    '37,638',
    '18.87%',
    '1541.10',
    '3.58%',
    '255.50',
    '16.58%',
    '-29.77%',
    '21.26%',
    '59,056',
    '44,292',
    '25.00%',
    '-6.13%',
    '0.066',
    '19.44%',
    '-0.57%',
  ],
  [
    27,
    '66.73',
    '28.92',
    '43.34%',
    '11.5%',
    '9.9%',
    '22.5%',
    '39,113',
    '29,049',
    '25.73%',
    '3136.35',
    '4.70%',
    '404.87',
    '12.91%',
    '-30.43%',
    '15.25%',
    '49,793',
    '33,878',
    '31.96%',
    '-6.23%',
    '0.116',
    '28.68%',
    '-2.95%',
  ],
  [
    28,
    '3.03',
    '1.43',
    '47.30%',
    '27.0%',
    '37.5%',
    '26.5%',
    '52,580',
    '47,076',
    '10.47%',
    '119.40',
    '3.94%',
    '23.90',
    '20.02%',
    '-27.28%',
    '28.57%',
    '70,961',
    '58,685',
    '17.30%',
    '-6.83%',
    '0.041',
    '12.40%',
    '-1.93%',
  ],
  [
    29,
    '12.67',
    '5.88',
    '46.45%',
    '36.3%',
    '26.5%',
    '17.4%',
    '52,063',
    '45,295',
    '13.00%',
    '482.62',
    '3.81%',
    '135.13',
    '28.00%',
    '-18.45%',
    '23.66%',
    '63,834',
    '51,068',
    '20.00%',
    '-7.00%',
    '0.120',
    '14.04%',
    '-1.04%',
  ],
  [
    30,
    '0.21',
    '0.08',
    '39.17%',
    '27.0%',
    '13.0%',
    '7.4%',
    '34,176',
    '30,553',
    '10.60%',
    '7.10',
    '3.35%',
    '0.80',
    '11.27%',
    '-27.91%',
    '20.00%',
    '46,289',
    '37,680',
    '18.60%',
    '-8.00%',
    '0.217',
    '7.20%',
    '3.40%',
  ],
  [
    31,
    '0.99',
    '0.46',
    '46.62%',
    '37.5%',
    '36.7%',
    '43.8%',
    '34,965',
    '32,133',
    '8.10%',
    '32.10',
    '3.23%',
    '5.60',
    '17.45%',
    '-29.18%',
    '21.88%',
    '51,638',
    '43,273',
    '16.20%',
    '-8.10%',
    '0.053',
    '0.95%',
    '7.15%',
  ],
  [
    32,
    '4.59',
    '2.10',
    '45.71%',
    '40.5%',
    '9.9%',
    '0.0%',
    '21,711',
    '19,157',
    '11.76%',
    '158.10',
    '3.45%',
    '20.70',
    '13.09%',
    '-32.61%',
    '18.03%',
    '35,772',
    '27,902',
    '22.00%',
    '-10.24%',
    '0.252',
    '11.99%',
    '-0.23%',
  ],
  [
    33,
    '25.77',
    '10.92',
    '42.37%',
    '26.5%',
    '31.0%',
    '43.8%',
    '35,397',
    '33,450',
    '5.50%',
    '584.80',
    '2.27%',
    '83.10',
    '14.21%',
    '-28.16%',
    '33.33%',
    '44,758',
    '36,970',
    '17.40%',
    '-11.90%',
    '0.085',
    '7.62%',
    '-2.12%',
  ],
  [
    34,
    '5.35',
    '2.37',
    '44.35%',
    '29.6%',
    '20.0%',
    '18.7%',
    '23,722',
    '19,102',
    '19.48%',
    '180.90',
    '3.38%',
    '20.20',
    '11.17%',
    '-33.18%',
    '23.08%',
    '42,346',
    '28,584',
    '32.50%',
    '-13.02%',
    '0.129',
    '18.70%',
    '0.78%',
  ],
  [
    35,
    '9.16',
    '3.93',
    '42.87%',
    '31.5%',
    '13.8%',
    '14.5%',
    '15,154',
    '14,275',
    '5.80%',
    '167.70',
    '1.83%',
    '44.10',
    '26.30%',
    '-16.57%',
    '31.51%',
    '29,223',
    '23,641',
    '19.10%',
    '-13.30%',
    '0.339',
    '8.80%',
    '-3.00%',
  ],
  [
    36,
    '0.28',
    '0.13',
    '45.32%',
    '17.4%',
    '28.6%',
    '26.5%',
    '62,636',
    '59,191',
    '5.50%',
    '10.80',
    '3.88%',
    '1.50',
    '13.89%',
    '-31.43%',
    '28.57%',
    '72,756',
    '58,932',
    '19.00%',
    '-13.50%',
    '0.075',
    '6.65%',
    '-1.15%',
  ],
  [
    37,
    '2.76',
    '1.25',
    '45.24%',
    '31.5%',
    '20.0%',
    '0.0%',
    '23,508',
    '20,363',
    '13.38%',
    '73.20',
    '2.65%',
    '6.80',
    '9.29%',
    '-35.95%',
    '24.81%',
    '29,927',
    '21,637',
    '27.70%',
    '-14.32%',
    '0.179',
    '14.85%',
    '-1.47%',
  ],
  [
    38,
    '4.80',
    '2.15',
    '44.70%',
    '25.9%',
    '20.0%',
    '9.9%',
    '25,124',
    '22,455',
    '10.62%',
    '51.20',
    '1.07%',
    '6.50',
    '12.70%',
    '-32.01%',
    '30.07%',
    '31,551',
    '23,537',
    '25.40%',
    '-14.78%',
    '0.119',
    '13.59%',
    '-2.96%',
  ],
  [
    39,
    '1.48',
    '0.76',
    '51.17%',
    '39.8%',
    '23.7%',
    '21.3%',
    '22,949',
    '19,690',
    '14.20%',
    '34.10',
    '2.31%',
    '8.50',
    '24.93%',
    '-26.24%',
    '17.36%',
    '38,138',
    '26,888',
    '29.50%',
    '-15.30%',
    '0.121',
    '12.62%',
    '1.58%',
  ],
  [
    40,
    '17.26',
    '7.75',
    '44.88%',
    '40.1%',
    '27.5%',
    '28.1%',
    '25,921',
    '23,925',
    '7.70%',
    '431.80',
    '2.50%',
    '62.60',
    '14.50%',
    '-30.38%',
    '25.93%',
    '44,633',
    '33,251',
    '25.50%',
    '-17.80%',
    '0.137',
    '5.85%',
    '1.85%',
  ],
]

export const rowsGBP = [
  [
    0,
    '5.18',
    '2.53',
    '48.78%',
    '32.4%',
    '34.6%',
    '28.6%',
    '17,416',
    '14,218',
    '18.36%',
    '108.80',
    '2.10%',
    '17.50',
    '16.08%',
    '-32.69%',
    '30.56%',
    '27,603',
    '24,540',
    '11.10%',
    '7.26%',
    '0.091',
    '13.13%',
    '5.23%',
  ],
  [
    1,
    '159.19',
    '74.43',
    '46.76%',
    '43.5%',
    '19.4%',
    '25.9%',
    '42,709',
    '34,645',
    '18.88%',
    '6049.11',
    '3.80%',
    '1488.64',
    '24.61%',
    '-22.15%',
    '24.24%',
    '69,768',
    '61,492',
    '11.86%',
    '7.02%',
    '0.203',
    '18.81%',
    '0.07%',
  ],
  [
    2,
    '0.99',
    '0.50',
    '50.25%',
    '44.4%',
    '18.0%',
    '23.1%',
    '15,896',
    '13,194',
    '17.00%',
    '19.70',
    '1.99%',
    '4.90',
    '24.87%',
    '-25.38%',
    '16.67%',
    '28,744',
    '25,611',
    '10.90%',
    '6.10%',
    '0.191',
    '17.28%',
    '-0.28%',
  ],
  [
    3,
    '2.68',
    '1.29',
    '48.14%',
    '33.8%',
    '41.5%',
    '62.5%',
    '29,910',
    '24,623',
    '17.68%',
    '162.30',
    '6.04%',
    '35.60',
    '21.93%',
    '-26.20%',
    '20.00%',
    '38,555',
    '33,350',
    '13.50%',
    '4.18%',
    '0.056',
    '19.59%',
    '-1.91%',
  ],
  [
    4,
    '29.56',
    '14.22',
    '48.13%',
    '31.5%',
    '25.9%',
    '50.0%',
    '30,524',
    '25,701',
    '15.80%',
    '1003.80',
    '3.40%',
    '181.60',
    '18.09%',
    '-30.03%',
    '25.37%',
    '42,071',
    '37,106',
    '11.80%',
    '4.00%',
    '0.102',
    '12.36%',
    '3.44%',
  ],
  [
    5,
    '5.28',
    '2.51',
    '47.62%',
    '39.4%',
    '43.5%',
    '52.2%',
    '30,399',
    '26,143',
    '14.00%',
    '310.80',
    '5.89%',
    '64.70',
    '20.82%',
    '-26.80%',
    '22.48%',
    '39,516',
    '35,327',
    '10.60%',
    '3.40%',
    '0.048',
    '14.86%',
    '-0.86%',
  ],
  [
    6,
    '33.23',
    '15.51',
    '46.69%',
    '35.5%',
    '29.6%',
    '22.5%',
    '30,413',
    '24,649',
    '18.95%',
    '1608.20',
    '4.84%',
    '260.60',
    '16.20%',
    '-30.48%',
    '31.03%',
    '41,986',
    '34,933',
    '16.80%',
    '2.15%',
    '0.131',
    '19.37%',
    '-0.41%',
  ],
  [
    7,
    '0.69',
    '0.34',
    '48.54%',
    '30.6%',
    '23.7%',
    '46.2%',
    '16,771',
    '12,260',
    '26.90%',
    '34.10',
    '4.93%',
    '6.40',
    '18.77%',
    '-29.77%',
    '21.26%',
    '25,745',
    '19,180',
    '25.50%',
    '1.40%',
    '0.131',
    '27.75%',
    '-0.85%',
  ],
  [
    8,
    '22.82',
    '10.61',
    '46.48%',
    '31.5%',
    '40.1%',
    '30.6%',
    '26,506',
    '22,557',
    '14.90%',
    '557.60',
    '2.44%',
    '85.80',
    '15.39%',
    '-31.10%',
    '25.93%',
    '34,473',
    '29,750',
    '13.70%',
    '1.20%',
    '0.081',
    '14.85%',
    '0.05%',
  ],
  [
    9,
    '0.40',
    '0.19',
    '48.61%',
    '22.5%',
    '19.4%',
    '9.1%',
    '25,187',
    '21,661',
    '14.00%',
    '7.90',
    '1.99%',
    '1.60',
    '20.25%',
    '-28.36%',
    '28.57%',
    '28,716',
    '24,839',
    '13.50%',
    '0.50%',
    '0.116',
    '16.80%',
    '-2.80%',
  ],
  [
    10,
    '0.20',
    '0.09',
    '46.87%',
    '38.3%',
    '41.2%',
    '44.4%',
    '39,749',
    '34,297',
    '13.72%',
    '7.70',
    '3.92%',
    '1.70',
    '22.08%',
    '-24.79%',
    '27.54%',
    '39,749',
    '33,985',
    '14.50%',
    '-0.78%',
    '0.051',
    '16.01%',
    '-2.29%',
  ],
  [
    11,
    '30.52',
    '9.63',
    '31.55%',
    '13.0%',
    '15.3%',
    '3.8%',
    '16,326',
    '15,203',
    '6.88%',
    '245.20',
    '0.80%',
    '24.30',
    '9.91%',
    '-21.64%',
    '37.11%',
    '35,738',
    '32,730',
    '8.42%',
    '-1.54%',
    '0.328',
    '3.10%',
    '3.78%',
  ],
  [
    12,
    '2.60',
    '1.23',
    '47.39%',
    '40.1%',
    '31.5%',
    '33.3%',
    '27,972',
    '25,756',
    '7.92%',
    '96.13',
    '3.70%',
    '17.24',
    '17.93%',
    '-29.46%',
    '27.01%',
    '35,610',
    '32,107',
    '9.84%',
    '-1.92%',
    '0.158',
    '7.01%',
    '0.91%',
  ],
  [
    13,
    '8.97',
    '4.16',
    '46.42%',
    '25.9%',
    '37.5%',
    '46.8%',
    '37,511',
    '31,472',
    '16.10%',
    '422.20',
    '4.71%',
    '65.70',
    '15.56%',
    '-30.85%',
    '18.70%',
    '49,636',
    '40,503',
    '18.40%',
    '-2.30%',
    '0.044',
    '17.84%',
    '-1.74%',
  ],
  [
    14,
    '19.44',
    '9.20',
    '47.32%',
    '35.5%',
    '25.9%',
    '30.6%',
    '34,366',
    '27,965',
    '18.63%',
    '900.30',
    '4.63%',
    '224.00',
    '24.88%',
    '-22.44%',
    '24.81%',
    '47,770',
    '37,721',
    '21.04%',
    '-2.41%',
    '0.098',
    '18.98%',
    '-0.35%',
  ],
  [
    15,
    '1.76',
    '0.81',
    '46.04%',
    '23.1%',
    '15.3%',
    '20.0%',
    '16,932',
    '15,171',
    '10.40%',
    '52.30',
    '2.98%',
    '6.90',
    '13.19%',
    '-32.84%',
    '26.47%',
    '24,402',
    '21,229',
    '13.00%',
    '-2.60%',
    '0.141',
    '5.70%',
    '4.70%',
  ],
  [
    16,
    '2.19',
    '0.99',
    '45.09%',
    '34.2%',
    '22.5%',
    '28.6%',
    '36,694',
    '31,492',
    '14.17%',
    '78.10',
    '3.56%',
    '14.80',
    '18.95%',
    '-26.14%',
    '24.81%',
    '51,991',
    '42,996',
    '17.30%',
    '-3.13%',
    '0.127',
    '13.37%',
    '0.80%',
  ],
  [
    17,
    '4.49',
    '2.10',
    '46.82%',
    '29.6%',
    '30.6%',
    '30.6%',
    '34,289',
    '27,647',
    '19.37%',
    '178.60',
    '3.98%',
    '30.70',
    '17.19%',
    '-29.63%',
    '20.63%',
    '47,215',
    '36,498',
    '22.70%',
    '-3.33%',
    '0.078',
    '21.59%',
    '-2.22%',
  ],
  [
    18,
    '3.31',
    '1.55',
    '46.91%',
    '36.7%',
    '20.6%',
    '35.1%',
    '10,304',
    '8,717',
    '15.40%',
    '80.90',
    '2.44%',
    '24.50',
    '30.28%',
    '-16.63%',
    '28.57%',
    '23,516',
    '19,001',
    '19.20%',
    '-3.80%',
    '0.223',
    '13.00%',
    '2.40%',
  ],
  [
    19,
    '27.25',
    '11.53',
    '42.31%',
    '10.7%',
    '17.4%',
    '5.7%',
    '23,003',
    '14,452',
    '37.18%',
    '1008.15',
    '3.70%',
    '161.41',
    '16.01%',
    '-26.30%',
    '21.26%',
    '29,284',
    '15,761',
    '41.17%',
    '-3.99%',
    '0.067',
    '39.61%',
    '-2.43%',
  ],
  [
    20,
    '53.68',
    '20.50',
    '38.20%',
    '35.9%',
    '42.5%',
    '17.4%',
    '10,871',
    '9,059',
    '16.67%',
    '461.29',
    '0.86%',
    '65.61',
    '14.22%',
    '-23.97%',
    '29.08%',
    '13,839',
    '10,974',
    '20.70%',
    '-4.04%',
    '0.345',
    '11.63%',
    '5.04%',
  ],
  [
    21,
    '2.77',
    '1.30',
    '47.03%',
    '35.9%',
    '39.8%',
    '47.1%',
    '38,087',
    '33,892',
    '11.01%',
    '113.10',
    '4.09%',
    '22.00',
    '19.45%',
    '-27.58%',
    '19.35%',
    '49,058',
    '41,503',
    '15.40%',
    '-4.39%',
    '0.053',
    '12.08%',
    '-1.07%',
  ],
  [
    22,
    '4.84',
    '2.26',
    '46.60%',
    '35.1%',
    '32.0%',
    '42.9%',
    '42,688',
    '35,132',
    '17.70%',
    '216.30',
    '4.47%',
    '31.60',
    '14.61%',
    '-31.99%',
    '21.88%',
    '53,939',
    '41,911',
    '22.30%',
    '-4.60%',
    '0.040',
    '18.93%',
    '-1.23%',
  ],
  [
    23,
    '8.68',
    '3.56',
    '41.04%',
    '25.4%',
    '16.0%',
    '34.6%',
    '20,188',
    '15,938',
    '21.05%',
    '321.09',
    '3.70%',
    '49.86',
    '15.53%',
    '-25.51%',
    '15.97%',
    '25,701',
    '18,980',
    '26.15%',
    '-5.10%',
    '0.322',
    '16.00%',
    '5.05%',
  ],
  [
    24,
    '3.93',
    '1.86',
    '47.30%',
    '32.9%',
    '26.5%',
    '18.0%',
    '24,156',
    '18,883',
    '21.83%',
    '236.27',
    '6.02%',
    '25.99',
    '11.00%',
    '-36.30%',
    '24.81%',
    '30,752',
    '22,414',
    '27.12%',
    '-5.29%',
    '0.103',
    '20.70%',
    '1.13%',
  ],
  [
    25,
    '4.98',
    '2.29',
    '46.11%',
    '32.4%',
    '39.4%',
    '23.1%',
    '35,207',
    '32,918',
    '6.50%',
    '193.80',
    '3.89%',
    '27.30',
    '14.09%',
    '-32.02%',
    '18.03%',
    '43,710',
    '38,553',
    '11.80%',
    '-5.30%',
    '0.073',
    '8.62%',
    '-2.12%',
  ],
  [
    26,
    '43.04',
    '19.95',
    '46.35%',
    '29.1%',
    '36.3%',
    '33.3%',
    '32,936',
    '26,723',
    '18.87%',
    '1541.10',
    '3.58%',
    '255.50',
    '16.58%',
    '-29.77%',
    '21.26%',
    '41,930',
    '31,447',
    '25.00%',
    '-6.13%',
    '0.066',
    '19.44%',
    '-0.57%',
  ],
  [
    27,
    '66.73',
    '28.92',
    '43.34%',
    '11.5%',
    '9.9%',
    '22.5%',
    '27,770',
    '20,624',
    '25.73%',
    '3136.35',
    '4.70%',
    '404.87',
    '12.91%',
    '-30.43%',
    '15.25%',
    '35,353',
    '24,053',
    '31.96%',
    '-6.23%',
    '0.116',
    '28.68%',
    '-2.95%',
  ],
  [
    28,
    '3.03',
    '1.43',
    '47.30%',
    '27.0%',
    '37.5%',
    '26.5%',
    '37,332',
    '33,424',
    '10.47%',
    '119.40',
    '3.94%',
    '23.90',
    '20.02%',
    '-27.28%',
    '28.57%',
    '50,383',
    '41,666',
    '17.30%',
    '-6.83%',
    '0.041',
    '12.40%',
    '-1.93%',
  ],
  [
    29,
    '12.67',
    '5.88',
    '46.45%',
    '36.3%',
    '26.5%',
    '17.4%',
    '36,965',
    '32,159',
    '13.00%',
    '482.62',
    '3.81%',
    '135.13',
    '28.00%',
    '-18.45%',
    '23.66%',
    '45,322',
    '36,258',
    '20.00%',
    '-7.00%',
    '0.120',
    '14.04%',
    '-1.04%',
  ],
  [
    30,
    '0.21',
    '0.08',
    '39.17%',
    '27.0%',
    '13.0%',
    '7.4%',
    '24,265',
    '21,693',
    '10.60%',
    '7.10',
    '3.35%',
    '0.80',
    '11.27%',
    '-27.91%',
    '20.00%',
    '32,865',
    '26,752',
    '18.60%',
    '-8.00%',
    '0.217',
    '7.20%',
    '3.40%',
  ],
  [
    31,
    '0.99',
    '0.46',
    '46.62%',
    '37.5%',
    '36.7%',
    '43.8%',
    '24,825',
    '22,814',
    '8.10%',
    '32.10',
    '3.23%',
    '5.60',
    '17.45%',
    '-29.18%',
    '21.88%',
    '36,663',
    '30,724',
    '16.20%',
    '-8.10%',
    '0.053',
    '0.95%',
    '7.15%',
  ],
  [
    32,
    '4.59',
    '2.10',
    '45.71%',
    '40.5%',
    '9.9%',
    '0.0%',
    '15,415',
    '13,602',
    '11.76%',
    '158.10',
    '3.45%',
    '20.70',
    '13.09%',
    '-32.61%',
    '18.03%',
    '25,398',
    '19,811',
    '22.00%',
    '-10.24%',
    '0.252',
    '11.99%',
    '-0.23%',
  ],
  [
    33,
    '25.77',
    '10.92',
    '42.37%',
    '26.5%',
    '31.0%',
    '43.8%',
    '25,132',
    '23,750',
    '5.50%',
    '584.80',
    '2.27%',
    '83.10',
    '14.21%',
    '-28.16%',
    '33.33%',
    '31,778',
    '26,249',
    '17.40%',
    '-11.90%',
    '0.085',
    '7.62%',
    '-2.12%',
  ],
  [
    34,
    '5.35',
    '2.37',
    '44.35%',
    '29.6%',
    '20.0%',
    '18.7%',
    '16,843',
    '13,562',
    '19.48%',
    '180.90',
    '3.38%',
    '20.20',
    '11.17%',
    '-33.18%',
    '23.08%',
    '30,066',
    '20,295',
    '32.50%',
    '-13.02%',
    '0.129',
    '18.70%',
    '0.78%',
  ],
  [
    35,
    '9.16',
    '3.93',
    '42.87%',
    '31.5%',
    '13.8%',
    '14.5%',
    '10,759',
    '10,135',
    '5.80%',
    '167.70',
    '1.83%',
    '44.10',
    '26.30%',
    '-16.57%',
    '31.51%',
    '20,748',
    '16,785',
    '19.10%',
    '-13.30%',
    '0.339',
    '8.80%',
    '-3.00%',
  ],
  [
    36,
    '0.28',
    '0.13',
    '45.32%',
    '17.4%',
    '28.6%',
    '26.5%',
    '44,472',
    '42,026',
    '5.50%',
    '10.80',
    '3.88%',
    '1.50',
    '13.89%',
    '-31.43%',
    '28.57%',
    '51,656',
    '41,842',
    '19.00%',
    '-13.50%',
    '0.075',
    '6.65%',
    '-1.15%',
  ],
  [
    37,
    '2.76',
    '1.25',
    '45.24%',
    '31.5%',
    '20.0%',
    '0.0%',
    '16,691',
    '14,458',
    '13.38%',
    '73.20',
    '2.65%',
    '6.80',
    '9.29%',
    '-35.95%',
    '24.81%',
    '21,248',
    '15,362',
    '27.70%',
    '-14.32%',
    '0.179',
    '14.85%',
    '-1.47%',
  ],
  [
    38,
    '4.80',
    '2.15',
    '44.70%',
    '25.9%',
    '20.0%',
    '9.9%',
    '17,838',
    '15,943',
    '10.62%',
    '51.20',
    '1.07%',
    '6.50',
    '12.70%',
    '-32.01%',
    '30.07%',
    '22,401',
    '16,711',
    '25.40%',
    '-14.78%',
    '0.119',
    '13.59%',
    '-2.96%',
  ],
  [
    39,
    '1.48',
    '0.76',
    '51.17%',
    '39.8%',
    '23.7%',
    '21.3%',
    '16,294',
    '13,980',
    '14.20%',
    '34.10',
    '2.31%',
    '8.50',
    '24.93%',
    '-26.24%',
    '17.36%',
    '27,078',
    '19,090',
    '29.50%',
    '-15.30%',
    '0.121',
    '12.62%',
    '1.58%',
  ],
  [
    40,
    '17.26',
    '7.75',
    '44.88%',
    '40.1%',
    '27.5%',
    '28.1%',
    '18,404',
    '16,987',
    '7.70%',
    '431.80',
    '2.50%',
    '62.60',
    '14.50%',
    '-30.38%',
    '25.93%',
    '31,689',
    '23,608',
    '25.50%',
    '-17.80%',
    '0.137',
    '5.85%',
    '1.85%',
  ],
]

export const rowsEUR = [
  [
    0,
    '5,18',
    '2,53',
    '48,78%',
    '32,4%',
    '34,6%',
    '28,6%',
    '19.868',
    '16.221',
    '18,36%',
    '108,80',
    '2,10%',
    '17,50',
    '16,08%',
    '-32,69%',
    '30,56%',
    '31.491',
    '27.996',
    '11,10%',
    '7,26%',
    '0,091',
    '13,13%',
    '5,23%',
  ],
  [
    1,
    '159,19',
    '74,43',
    '46,76%',
    '43,5%',
    '19,4%',
    '25,9%',
    '48.725',
    '39.524',
    '18,88%',
    '6049,11',
    '3,80%',
    '1488,64',
    '24,61%',
    '-22,15%',
    '24,24%',
    '79.595',
    '70.153',
    '11,86%',
    '7,02%',
    '0,203',
    '18,81%',
    '0,07%',
  ],
  [
    2,
    '0,99',
    '0,50',
    '50,25%',
    '44,4%',
    '18,0%',
    '23,1%',
    '18.135',
    '15.052',
    '17,00%',
    '19,70',
    '1,99%',
    '4,90',
    '24,87%',
    '-25,38%',
    '16,67%',
    '32.792',
    '29.218',
    '10,90%',
    '6,10%',
    '0,191',
    '17,28%',
    '-0,28%',
  ],
  [
    3,
    '2,68',
    '1,29',
    '48,14%',
    '33,8%',
    '41,5%',
    '62,5%',
    '34.123',
    '28.091',
    '17,68%',
    '162,30',
    '6,04%',
    '35,60',
    '21,93%',
    '-26,20%',
    '20,00%',
    '43.985',
    '38.047',
    '13,50%',
    '4,18%',
    '0,056',
    '19,59%',
    '-1,91%',
  ],
  [
    4,
    '29,56',
    '14,22',
    '48,13%',
    '31,5%',
    '25,9%',
    '50,0%',
    '34.824',
    '29.321',
    '15,80%',
    '1003,80',
    '3,40%',
    '181,60',
    '18,09%',
    '-30,03%',
    '25,37%',
    '47.996',
    '42.333',
    '11,80%',
    '4,00%',
    '0,102',
    '12,36%',
    '3,44%',
  ],
  [
    5,
    '5,28',
    '2,51',
    '47,62%',
    '39,4%',
    '43,5%',
    '52,2%',
    '34.681',
    '29.826',
    '14,00%',
    '310,80',
    '5,89%',
    '64,70',
    '20,82%',
    '-26,80%',
    '22,48%',
    '45.082',
    '40.303',
    '10,60%',
    '3,40%',
    '0,048',
    '14,86%',
    '-0,86%',
  ],
  [
    6,
    '33,23',
    '15,51',
    '46,69%',
    '35,5%',
    '29,6%',
    '22,5%',
    '34.696',
    '28.121',
    '18,95%',
    '1608,20',
    '4,84%',
    '260,60',
    '16,20%',
    '-30,48%',
    '31,03%',
    '47.900',
    '39.853',
    '16,80%',
    '2,15%',
    '0,131',
    '19,37%',
    '-0,41%',
  ],
  [
    7,
    '0,69',
    '0,34',
    '48,54%',
    '30,6%',
    '23,7%',
    '46,2%',
    '19.133',
    '13.986',
    '26,90%',
    '34,10',
    '4,93%',
    '6,40',
    '18,77%',
    '-29,77%',
    '21,26%',
    '29.371',
    '21.881',
    '25,50%',
    '1,40%',
    '0,131',
    '27,75%',
    '-0,85%',
  ],
  [
    8,
    '22,82',
    '10,61',
    '46,48%',
    '31,5%',
    '40,1%',
    '30,6%',
    '30.240',
    '25.734',
    '14,90%',
    '557,60',
    '2,44%',
    '85,80',
    '15,39%',
    '-31,10%',
    '25,93%',
    '39.328',
    '33.940',
    '13,70%',
    '1,20%',
    '0,081',
    '14,85%',
    '0,05%',
  ],
  [
    9,
    '0,40',
    '0,19',
    '48,61%',
    '22,5%',
    '19,4%',
    '9,1%',
    '28.735',
    '24.712',
    '14,00%',
    '7,90',
    '1,99%',
    '1,60',
    '20,25%',
    '-28,36%',
    '28,57%',
    '32.760',
    '28.337',
    '13,50%',
    '0,50%',
    '0,116',
    '16,80%',
    '-2,80%',
  ],
  [
    10,
    '0,20',
    '0,09',
    '46,87%',
    '38,3%',
    '41,2%',
    '44,4%',
    '45.347',
    '39.127',
    '13,72%',
    '7,70',
    '3,92%',
    '1,70',
    '22,08%',
    '-24,79%',
    '27,54%',
    '45.347',
    '38.772',
    '14,50%',
    '-0,78%',
    '0,051',
    '16,01%',
    '-2,29%',
  ],
  [
    11,
    '30,52',
    '9,63',
    '31,55%',
    '13,0%',
    '15,3%',
    '3,8%',
    '18.626',
    '17.344',
    '6,88%',
    '245,20',
    '0,80%',
    '24,30',
    '9,91%',
    '-21,64%',
    '37,11%',
    '40.772',
    '37.340',
    '8,42%',
    '-1,54%',
    '0,328',
    '3,10%',
    '3,78%',
  ],
  [
    12,
    '2,60',
    '1,23',
    '47,39%',
    '40,1%',
    '31,5%',
    '33,3%',
    '31.912',
    '29.384',
    '7,92%',
    '96,13',
    '3,70%',
    '17,24',
    '17,93%',
    '-29,46%',
    '27,01%',
    '40.625',
    '36.629',
    '9,84%',
    '-1,92%',
    '0,158',
    '7,01%',
    '0,91%',
  ],
  [
    13,
    '8,97',
    '4,16',
    '46,42%',
    '25,9%',
    '37,5%',
    '46,8%',
    '42.795',
    '35.905',
    '16,10%',
    '422,20',
    '4,71%',
    '65,70',
    '15,56%',
    '-30,85%',
    '18,70%',
    '56.627',
    '46.208',
    '18,40%',
    '-2,30%',
    '0,044',
    '17,84%',
    '-1,74%',
  ],
  [
    14,
    '19,44',
    '9,20',
    '47,32%',
    '35,5%',
    '25,9%',
    '30,6%',
    '39.206',
    '31.903',
    '18,63%',
    '900,30',
    '4,63%',
    '224,00',
    '24,88%',
    '-22,44%',
    '24,81%',
    '54.498',
    '43.034',
    '21,04%',
    '-2,41%',
    '0,098',
    '18,98%',
    '-0,35%',
  ],
  [
    15,
    '1,76',
    '0,81',
    '46,04%',
    '23,1%',
    '15,3%',
    '20,0%',
    '19.316',
    '17.308',
    '10,40%',
    '52,30',
    '2,98%',
    '6,90',
    '13,19%',
    '-32,84%',
    '26,47%',
    '27.838',
    '24.219',
    '13,00%',
    '-2,60%',
    '0,141',
    '5,70%',
    '4,70%',
  ],
  [
    16,
    '2,19',
    '0,99',
    '45,09%',
    '34,2%',
    '22,5%',
    '28,6%',
    '41.862',
    '35.928',
    '14,17%',
    '78,10',
    '3,56%',
    '14,80',
    '18,95%',
    '-26,14%',
    '24,81%',
    '59.313',
    '49.052',
    '17,30%',
    '-3,13%',
    '0,127',
    '13,37%',
    '0,80%',
  ],
  [
    17,
    '4,49',
    '2,10',
    '46,82%',
    '29,6%',
    '30,6%',
    '30,6%',
    '39.119',
    '31.541',
    '19,37%',
    '178,60',
    '3,98%',
    '30,70',
    '17,19%',
    '-29,63%',
    '20,63%',
    '53.865',
    '41.638',
    '22,70%',
    '-3,33%',
    '0,078',
    '21,59%',
    '-2,22%',
  ],
  [
    18,
    '3,31',
    '1,55',
    '46,91%',
    '36,7%',
    '20,6%',
    '35,1%',
    '11.755',
    '9.945',
    '15,40%',
    '80,90',
    '2,44%',
    '24,50',
    '30,28%',
    '-16,63%',
    '28,57%',
    '26.829',
    '21.678',
    '19,20%',
    '-3,80%',
    '0,223',
    '13,00%',
    '2,40%',
  ],
  [
    19,
    '27,25',
    '11,53',
    '42,31%',
    '10,7%',
    '17,4%',
    '5,7%',
    '26.243',
    '16.487',
    '37,18%',
    '1008,15',
    '3,70%',
    '161,41',
    '16,01%',
    '-26,30%',
    '21,26%',
    '33.409',
    '17.981',
    '41,17%',
    '-3,99%',
    '0,067',
    '39,61%',
    '-2,43%',
  ],
  [
    20,
    '53,68',
    '20,50',
    '38,20%',
    '35,9%',
    '42,5%',
    '17,4%',
    '12.402',
    '10.335',
    '16,67%',
    '461,29',
    '0,86%',
    '65,61',
    '14,22%',
    '-23,97%',
    '29,08%',
    '15.788',
    '12.520',
    '20,70%',
    '-4,04%',
    '0,345',
    '11,63%',
    '5,04%',
  ],
  [
    21,
    '2,77',
    '1,30',
    '47,03%',
    '35,9%',
    '39,8%',
    '47,1%',
    '43.451',
    '38.666',
    '11,01%',
    '113,10',
    '4,09%',
    '22,00',
    '19,45%',
    '-27,58%',
    '19,35%',
    '55.967',
    '47.348',
    '15,40%',
    '-4,39%',
    '0,053',
    '12,08%',
    '-1,07%',
  ],
  [
    22,
    '4,84',
    '2,26',
    '46,60%',
    '35,1%',
    '32,0%',
    '42,9%',
    '48.700',
    '40.080',
    '17,70%',
    '216,30',
    '4,47%',
    '31,60',
    '14,61%',
    '-31,99%',
    '21,88%',
    '61.536',
    '47.814',
    '22,30%',
    '-4,60%',
    '0,040',
    '18,93%',
    '-1,23%',
  ],
  [
    23,
    '8,68',
    '3,56',
    '41,04%',
    '25,4%',
    '16,0%',
    '34,6%',
    '23.032',
    '18.183',
    '21,05%',
    '321,09',
    '3,70%',
    '49,86',
    '15,53%',
    '-25,51%',
    '15,97%',
    '29.320',
    '21.653',
    '26,15%',
    '-5,10%',
    '0,322',
    '16,00%',
    '5,05%',
  ],
  [
    24,
    '3,93',
    '1,86',
    '47,30%',
    '32,9%',
    '26,5%',
    '18,0%',
    '27.559',
    '21.543',
    '21,83%',
    '236,27',
    '6,02%',
    '25,99',
    '11,00%',
    '-36,30%',
    '24,81%',
    '35.084',
    '25.570',
    '27,12%',
    '-5,29%',
    '0,103',
    '20,70%',
    '1,13%',
  ],
  [
    25,
    '4,98',
    '2,29',
    '46,11%',
    '32,4%',
    '39,4%',
    '23,1%',
    '40.165',
    '37.555',
    '6,50%',
    '193,80',
    '3,89%',
    '27,30',
    '14,09%',
    '-32,02%',
    '18,03%',
    '49.867',
    '43.982',
    '11,80%',
    '-5,30%',
    '0,073',
    '8,62%',
    '-2,12%',
  ],
  [
    26,
    '43,04',
    '19,95',
    '46,35%',
    '29,1%',
    '36,3%',
    '33,3%',
    '37.575',
    '30.486',
    '18,87%',
    '1541,10',
    '3,58%',
    '255,50',
    '16,58%',
    '-29,77%',
    '21,26%',
    '47.835',
    '35.876',
    '25,00%',
    '-6,13%',
    '0,066',
    '19,44%',
    '-0,57%',
  ],
  [
    27,
    '66,73',
    '28,92',
    '43,34%',
    '11,5%',
    '9,9%',
    '22,5%',
    '31.682',
    '23.529',
    '25,73%',
    '3136,35',
    '4,70%',
    '404,87',
    '12,91%',
    '-30,43%',
    '15,25%',
    '40.332',
    '27.441',
    '31,96%',
    '-6,23%',
    '0,116',
    '28,68%',
    '-2,95%',
  ],
  [
    28,
    '3,03',
    '1,43',
    '47,30%',
    '27,0%',
    '37,5%',
    '26,5%',
    '42.590',
    '38.131',
    '10,47%',
    '119,40',
    '3,94%',
    '23,90',
    '20,02%',
    '-27,28%',
    '28,57%',
    '57.479',
    '47.535',
    '17,30%',
    '-6,83%',
    '0,041',
    '12,40%',
    '-1,93%',
  ],
  [
    29,
    '12,67',
    '5,88',
    '46,45%',
    '36,3%',
    '26,5%',
    '17,4%',
    '42.171',
    '36.689',
    '13,00%',
    '482,62',
    '3,81%',
    '135,13',
    '28,00%',
    '-18,45%',
    '23,66%',
    '51.706',
    '41.365',
    '20,00%',
    '-7,00%',
    '0,120',
    '14,04%',
    '-1,04%',
  ],
  [
    30,
    '0,21',
    '0,08',
    '39,17%',
    '27,0%',
    '13,0%',
    '7,4%',
    '27.683',
    '24.748',
    '10,60%',
    '7,10',
    '3,35%',
    '0,80',
    '11,27%',
    '-27,91%',
    '20,00%',
    '37.494',
    '30.520',
    '18,60%',
    '-8,00%',
    '0,217',
    '7,20%',
    '3,40%',
  ],
  [
    31,
    '0,99',
    '0,46',
    '46,62%',
    '37,5%',
    '36,7%',
    '43,8%',
    '28.322',
    '26.028',
    '8,10%',
    '32,10',
    '3,23%',
    '5,60',
    '17,45%',
    '-29,18%',
    '21,88%',
    '41.827',
    '35.051',
    '16,20%',
    '-8,10%',
    '0,053',
    '0,95%',
    '7,15%',
  ],
  [
    32,
    '4,59',
    '2,10',
    '45,71%',
    '40,5%',
    '9,9%',
    '0,0%',
    '17.586',
    '15.517',
    '11,76%',
    '158,10',
    '3,45%',
    '20,70',
    '13,09%',
    '-32,61%',
    '18,03%',
    '28.975',
    '22.601',
    '22,00%',
    '-10,24%',
    '0,252',
    '11,99%',
    '-0,23%',
  ],
  [
    33,
    '25,77',
    '10,92',
    '42,37%',
    '26,5%',
    '31,0%',
    '43,8%',
    '28.672',
    '27.095',
    '5,50%',
    '584,80',
    '2,27%',
    '83,10',
    '14,21%',
    '-28,16%',
    '33,33%',
    '36.254',
    '29.946',
    '17,40%',
    '-11,90%',
    '0,085',
    '7,62%',
    '-2,12%',
  ],
  [
    34,
    '5,35',
    '2,37',
    '44,35%',
    '29,6%',
    '20,0%',
    '18,7%',
    '19.215',
    '15.472',
    '19,48%',
    '180,90',
    '3,38%',
    '20,20',
    '11,17%',
    '-33,18%',
    '23,08%',
    '34.301',
    '23.153',
    '32,50%',
    '-13,02%',
    '0,129',
    '18,70%',
    '0,78%',
  ],
  [
    35,
    '9,16',
    '3,93',
    '42,87%',
    '31,5%',
    '13,8%',
    '14,5%',
    '12.275',
    '11.563',
    '5,80%',
    '167,70',
    '1,83%',
    '44,10',
    '26,30%',
    '-16,57%',
    '31,51%',
    '23.670',
    '19.149',
    '19,10%',
    '-13,30%',
    '0,339',
    '8,80%',
    '-3,00%',
  ],
  [
    36,
    '0,28',
    '0,13',
    '45,32%',
    '17,4%',
    '28,6%',
    '26,5%',
    '50.735',
    '47.945',
    '5,50%',
    '10,80',
    '3,88%',
    '1,50',
    '13,89%',
    '-31,43%',
    '28,57%',
    '58.932',
    '47.735',
    '19,00%',
    '-13,50%',
    '0,075',
    '6,65%',
    '-1,15%',
  ],
  [
    37,
    '2,76',
    '1,25',
    '45,24%',
    '31,5%',
    '20,0%',
    '0,0%',
    '19.041',
    '16.494',
    '13,38%',
    '73,20',
    '2,65%',
    '6,80',
    '9,29%',
    '-35,95%',
    '24,81%',
    '24.241',
    '17.526',
    '27,70%',
    '-14,32%',
    '0,179',
    '14,85%',
    '-1,47%',
  ],
  [
    38,
    '4,80',
    '2,15',
    '44,70%',
    '25,9%',
    '20,0%',
    '9,9%',
    '20.350',
    '18.188',
    '10,62%',
    '51,20',
    '1,07%',
    '6,50',
    '12,70%',
    '-32,01%',
    '30,07%',
    '25.556',
    '19.065',
    '25,40%',
    '-14,78%',
    '0,119',
    '13,59%',
    '-2,96%',
  ],
  [
    39,
    '1,48',
    '0,76',
    '51,17%',
    '39,8%',
    '23,7%',
    '21,3%',
    '18.589',
    '15.949',
    '14,20%',
    '34,10',
    '2,31%',
    '8,50',
    '24,93%',
    '-26,24%',
    '17,36%',
    '30.892',
    '21.779',
    '29,50%',
    '-15,30%',
    '0,121',
    '12,62%',
    '1,58%',
  ],
  [
    40,
    '17,26',
    '7,75',
    '44,88%',
    '40,1%',
    '27,5%',
    '28,1%',
    '20.996',
    '19.379',
    '7,70%',
    '431,80',
    '2,50%',
    '62,60',
    '14,50%',
    '-30,38%',
    '25,93%',
    '36.152',
    '26.934',
    '25,50%',
    '-17,80%',
    '0,137',
    '5,85%',
    '1,85%',
  ],
]

export const rows = {
  $: rowsUSD,
  '£': rowsGBP,
  '€': rowsEUR,
}



// WEBPACK FOOTER //
// ./src/App/women-in-tech/DataTable/data.js